import { createFileRoute } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { SubPage, SettingsGroup, RowLink } from "@/components/profile/SettingsKit";
import { Card } from "@/components/ui";
import { FileText, CircleHelp } from "@/icons";
import { Lock } from "lucide-react";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/settings_/help")({
  head: () =>
    buildHead({
      path: "/settings/help",
      title: "Help & support",
      description: "Answers to common questions about trading, deposits and withdrawals.",
    }),
  component: HelpPage,
});

// FAQ entries live in the account catalog as help.faq.<id>.{q,a}.
const FAQ_IDS = ["addFunds", "resolve", "secure"] as const;

function HelpPage() {
  const { t } = useTranslation("account");
  return (
    <SubPage title={t("help.title")} subtitle={t("help.subtitle")}>
      <Card className="mb-5 space-y-4 p-5">
        {FAQ_IDS.map((id) => (
          <section key={id}>
            <h2 className="mb-1 text-sm font-semibold text-fg">{t(`help.faq.${id}.q`)}</h2>
            <p className="text-sm leading-relaxed text-fg-muted">{t(`help.faq.${id}.a`)}</p>
          </section>
        ))}
        <p className="border-t border-border pt-4 text-sm text-fg-muted">
          <Trans
            t={t}
            i18nKey="help.stillNeedHelp"
            components={{
              support: <a href="mailto:support@smartmarket.app" className="font-medium text-primary hover:underline" />,
            }}
          />
        </p>
      </Card>

      <SettingsGroup title={t("help.legal")}>
        <RowLink to="/settings/privacy" icon={<Lock className="h-4 w-4" />} label={t("help.privacyPolicy")} />
        <RowLink to="/settings/terms" icon={<FileText className="h-4 w-4" />} label={t("help.terms")} />
      </SettingsGroup>

      <p className="px-1 text-xs text-fg-subtle">
        <CircleHelp className="mr-1 inline h-3.5 w-3.5" />
        {t("help.footer")}
      </p>
    </SubPage>
  );
}
